<mat-card class="mat-elevation-z3" style="position: relative;">
  <button *ngFor="let item of customPresets" mat-button (click)="selectRange(item)" class="datebtn">
    <span class="tooltip-ellipses">
      <div class="word-ellips"> {{ item | translate }}</div>
      <span class="tooltiptext tooltip-top"> {{ item | translate }}</span>
    </span>
  </button>
</mat-card>
  